import { render, staticRenderFns } from "./StorehouseInput.vue?vue&type=template&id=222c3ada&scoped=true&"
import script from "./StorehouseInput.vue?vue&type=script&lang=js&"
export * from "./StorehouseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c3ada",
  null
  
)

export default component.exports